"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@xstate/react");
const machine_1 = __importDefault(require("./stateMachine/machine"));
const util = __importStar(require("./stateMachine/util"));
const constants_1 = require("./common/constants");
const useCrmConnector = ({ initialContext, machineOptions = {}, interpreterOptions }) => {
    const machine = (0, react_1.useMemo)(() => (0, machine_1.default)(initialContext).withConfig(machineOptions), []);
    const [state, send] = (0, react_2.useMachine)(machine, interpreterOptions);
    const addReferral = react_1.default.useCallback((referredProvider) => {
        send(constants_1.CrmConnectorEvents.ADD_REFERRAL, {
            data: referredProvider
        });
    }, [send]);
    const removeReferral = react_1.default.useCallback((referredProvider) => {
        send(constants_1.CrmConnectorEvents.REMOVE_REFERRAL, {
            data: referredProvider
        });
    }, [send]);
    const sendReferralData = react_1.default.useCallback((referralData) => {
        send(constants_1.CrmConnectorEvents.SEND_REFERRAL_DATA, {
            data: referralData
        });
    }, [send]);
    const sendBookingData = react_1.default.useCallback(({ appointment, location, provider, searchSummary }) => {
        send(constants_1.CrmConnectorEvents.SEND_BOOKING_DATA, {
            data: { appointment, location, provider, searchSummary }
        });
    }, [send]);
    const isInitializing = react_1.default.useCallback(() => {
        return util.isInitializing(state);
    }, [state]);
    const canRefer = react_1.default.useCallback(() => {
        return util.canRefer(state);
    }, [state]);
    const canBook = react_1.default.useCallback(() => {
        return util.canBook(state);
    }, [state]);
    const hasReferrals = react_1.default.useCallback(() => {
        return util.hasReferrals(state);
    }, [state]);
    const hasMaxReferrals = react_1.default.useCallback(() => {
        return util.hasMaxReferrals(state);
    }, [state]);
    const isReferDisabled = react_1.default.useCallback(() => {
        return util.isReferDisabled(state);
    }, [state]);
    const showSpinner = react_1.default.useCallback(() => {
        return util.showSpinner(state);
    }, [state]);
    const hasErrors = react_1.default.useCallback(() => {
        return util.hasErrors(state);
    }, [state]);
    const hasPatientValidationErrors = react_1.default.useCallback(() => {
        return util.hasPatientValidationErrors(state);
    }, [state]);
    const hasPatientValidationErrorsForBooking = react_1.default.useCallback(() => {
        return util.hasPatientValidationErrorsForBooking(state);
    }, [state]);
    const hasPatientValidationErrorsForReferral = react_1.default.useCallback(() => {
        return util.hasPatientValidationErrorsForReferral(state);
    }, [state]);
    const dismissError = react_1.default.useCallback(() => {
        send(constants_1.CrmConnectorEvents.DISMISS_ERROR);
    }, [send]);
    return {
        state,
        // Event handlers
        addReferral,
        removeReferral,
        sendBookingData,
        sendReferralData,
        dismissError,
        // State matchers
        isInitializing,
        canRefer,
        canBook,
        hasReferrals,
        hasMaxReferrals,
        isReferDisabled,
        showSpinner,
        hasErrors,
        hasPatientValidationErrors,
        hasPatientValidationErrorsForBooking,
        hasPatientValidationErrorsForReferral
    };
};
exports.default = useCrmConnector;
//# sourceMappingURL=useCrmConnector.js.map